import axios from 'axios'
import router from '../router'
import { Message } from 'element-ui'
import Config from '@/config'
import { showLoading, hideLoading } from './loading'

class HttpRequest {
    constructor(options) {
        let config = {
            withToken: true, //是否添加请求头TOKEN
            showLoading: false, //是否显示加载弹框
            alertError: false, //是否显示错误提示
            timeout: 1000000, //Ajax超时时间
            redirectLogin: true, //遇到401错误是否跳转到登录页
            loginRoute: '/login' //登录页路由
        }
        this.config = Object.assign(config, options)
    }

    // 默认配置
    getDefaultOption() {
        const option = Object.assign({}, this.config)
        if (option.withToken == true) {
            const authToken = sessionStorage.getItem('authToken')
            if (authToken === 'undefined' || authToken === 'null' || authToken === '') {
                return option
            }
            option.headers = {
                'X-Auth-Token': authToken
            }
        }
        return option
    }

    // 错误提示
    alertErrorMsg(errCode) {
        switch (errCode) {
            case 400:
                Message.error('400:错误请求')
                break
            case 401:
                Message.error('401:未授权，请重新登录')
                break
            case 403:
                Message.error('403:拒绝访问')
                break
            case 404:
                Message.error('404:请求错误,未找到该资源')
                break
            case 405:
                Message.error('405:请求方法未允许')
                break
            case 408:
                Message.error('408:请求超时')
                break
            case 500:
                Message.error('500:服务器端出错')
                break
            case 501:
                Message.error('501:网络未实现')
                break
            case 502:
                Message.error('502:网络错误')
                break
            case 503:
                Message.error('503:服务不可用')
                break
            case 504:
                Message.error('504:网络超时')
                break
            case 505:
                Message.error('505:http版本不支持该请求')
                break
            case 601:
                Message.error('连接服务器失败')
                break
            case 602:
                Message.error('服务器响应超时，请刷新当前页')
                break
            default:
                Message.error(`连接错误` + errCode)
        }
    }

    // 登录页跳转
    redirectLogin() {
        router.push({ path: this.config.loginRoute })
        sessionStorage.removeItem('authToken')
    }

    // 拦截器设置
    interceptors(instance, options) {
        // 请求拦截
        instance.interceptors.request.use(
            config => {
                // 显示遮罩层
                if (options.showLoading) showLoading()
                return config
            },
            error => {
                return error
            }
        )

        // 响应拦截
        instance.interceptors.response.use(
            res => {
                if (options.showLoading) hideLoading()
                const { data } = res
                return data
            },
            error => {
                /***** 接收到异常响应的处理开始 *****/
                let errCode = 0
                if (error && error.response) {
                    errCode = error.response.status
                    switch (errCode) {
                        case 401:
                            // 未经授权处理
                            if (options.redirectLogin) this.redirectLogin()
                            break
                        default:
                            break
                    }
                } else {
                    // 超时处理
                    if (JSON.stringify(error).includes('timeout')) errCode = 601
                    else errCode = 602
                }
                if (options.showLoading) hideLoading()
                if (options.alertError) this.alertErrorMsg(errCode)
                return error.response
            }
        )
    }

    // 执行请求
    request(options) {
        const instance = axios.create()
        {
            baseURL: Config.TPM.Base_url
        }
        const defaultOption = this.getDefaultOption()
        options.headers = Object.assign(defaultOption.headers || {}, options.headers || {})
        options = Object.assign(defaultOption, options)
        this.interceptors(instance, options)
        return instance(options)
    }

    emsRequest(options) {
        const instance = axios.create()
        {
            baseURL: Config.MES.Base_url
        }
        const defaultOption = this.getDefaultOption()
        options.headers = Object.assign(defaultOption.headers || {}, options.headers || {})
        options = Object.assign(defaultOption, options)
        this.interceptors(instance, options)
        return instance(options)
    }
}

export default HttpRequest
